import type { KanbanStage } from '@/hooks/useFizbo';

export type { KanbanStage } from '@/hooks/useFizbo';

// DEPRECATED: fizboListings is now fetched from Supabase via useFizbo hook
// Components should use useFizbo().listings instead
export const fizboListings: Array<{
  id: string;
  listingNo: string;
  ownerName: string;
  phone: string;
  propertyType: string;
  transactionType: string;
  location: string;
  status: string;
  daysOld: number;
  fatigueScore: number;
  kanbanStage: KanbanStage;
  price: number;
  sqm: number | null;
  sellabilityScore: number;
  notes: string;
  priceHistory: { date: string; price: number }[];
  createdAt: string;
}> = [];

export const kanbanStages: KanbanStage[] = ['Yeni', 'İletişim', 'Görüşme', 'Teklif', 'Kapandı'];

export const competitorListings = [
  {
    id: 'c1',
    agency: 'Remax Samsun',
    location: 'Atakum, İnönü Bulvarı',
    propertyType: 'Daire',
    sqm: 115,
    price: 2950000,
    daysOnMarket: 18,
    status: 'Aktif',
    pricePerSqm: 25652,
  },
  {
    id: 'c2',
    agency: 'Century 21',
    location: 'Atakum, Kurupelit',
    propertyType: 'Daire',
    sqm: 125,
    price: 3100000,
    daysOnMarket: 32,
    status: 'Aktif',
    pricePerSqm: 24800,
  },
  {
    id: 'c3',
    agency: 'Sahibinden',
    location: 'Atakum, İnönü Bulvarı',
    propertyType: 'Daire',
    sqm: 118,
    price: 2750000,
    daysOnMarket: 45,
    status: 'Aktif',
    pricePerSqm: 23305,
  },
  {
    id: 'c4',
    agency: 'ERA Türkiye',
    location: 'Atakum, Merkez',
    propertyType: 'Daire',
    sqm: 130,
    price: 3350000,
    daysOnMarket: 12,
    status: 'Aktif',
    pricePerSqm: 25769,
  },
  {
    id: 'c5',
    agency: 'Coldwell Banker',
    location: 'Atakum, Kurupelit',
    propertyType: 'Daire',
    sqm: 108,
    price: 2600000,
    daysOnMarket: 67,
    status: 'Satıldı',
    pricePerSqm: 24074,
  },
];

export const sellabilityFactors = [
  { label: 'Lokasyon Puanı', score: 88, icon: 'ri-map-pin-line', color: 'text-green-500' },
  { label: 'Fiyat Uygunluğu', score: 82, icon: 'ri-price-tag-3-line', color: 'text-green-500' },
  { label: 'Görsel Kalitesi', score: 65, icon: 'ri-image-line', color: 'text-yellow-500' },
  { label: 'İlan Yaşı', score: 95, icon: 'ri-time-line', color: 'text-green-500' },
  { label: 'Rakip Durumu', score: 70, icon: 'ri-bar-chart-line', color: 'text-yellow-500' },
  { label: 'Müşteri İlgisi', score: 78, icon: 'ri-user-heart-line', color: 'text-green-500' },
];

export const fizboStats = {
  totalToday: 3,
  totalActive: 42,
  pendingReturns: 8,
  todayCalls: 12,
  conversionRate: 68,
};

export const listingLifecycle = [
  { date: '2026-04-25', event: 'İlan Oluşturuldu', type: 'created', detail: 'Sistem tarafından otomatik kaydedildi.' },
  { date: '2026-04-25', event: 'İlk Arama Yapıldı', type: 'call', detail: 'Mal sahibiyle ilk iletişim kuruldu.' },
  { date: '2026-04-26', event: 'Fiyat Güncellendi', type: 'price', detail: '2.950.000 ₺ → 2.850.000 ₺ indirim yapıldı.' },
  { date: '2026-04-26', event: 'Yetki Görüşmesi', type: 'meeting', detail: 'Yüz yüze görüşme gerçekleştirildi.' },
  { date: '2026-04-27', event: 'Fotoğraf Çekimi', type: 'photo', detail: '12 adet profesyonel fotoğraf yüklendi.' },
  { date: '2026-04-28', event: 'Portföye Alındı', type: 'portfolio', detail: 'İlan aktif portföye eklendi.' },
];

export const customerInterestData = [
  { segment: 'Yatırımcı', match: 92, count: 14, icon: 'ri-funds-line', color: 'text-green-500', bg: 'bg-green-50 dark:bg-green-900/20' },
  { segment: 'Aile (3+1)', match: 85, count: 22, icon: 'ri-home-heart-line', color: 'text-sky-500', bg: 'bg-sky-50 dark:bg-sky-900/20' },
  { segment: 'İlk Ev Alıcısı', match: 71, count: 9, icon: 'ri-user-star-line', color: 'text-amber-500', bg: 'bg-amber-50 dark:bg-amber-900/20' },
  { segment: 'Kiracı Dönüşüm', match: 58, count: 6, icon: 'ri-key-line', color: 'text-violet-500', bg: 'bg-violet-50 dark:bg-violet-900/20' },
];

export const behaviorAnalysisData = {
  weeklyViews: [
    { day: 'Pzt', views: 12, clicks: 4 },
    { day: 'Sal', views: 18, clicks: 7 },
    { day: 'Çar', views: 9, clicks: 3 },
    { day: 'Per', views: 24, clicks: 11 },
    { day: 'Cum', views: 31, clicks: 14 },
    { day: 'Cmt', views: 27, clicks: 9 },
    { day: 'Paz', views: 15, clicks: 5 },
  ],
  topPhotos: [
    { name: 'Salon Görünümü', views: 142, pct: 88 },
    { name: 'Mutfak', views: 118, pct: 73 },
    { name: 'Ana Yatak Odası', views: 97, pct: 60 },
    { name: 'Balkon / Manzara', views: 89, pct: 55 },
    { name: 'Banyo', views: 64, pct: 40 },
  ],
  totalViews: 136,
  totalClicks: 53,
  avgTimeOnListing: '2dk 18sn',
  phoneRevealCount: 17,
};

export const locationPoiData = [
  { category: 'Eğitim', items: [
    { name: 'Atakum İlkokulu', distance: '320m', score: 95, icon: 'ri-school-line' },
    { name: 'Samsun Üniversitesi', distance: '1.2km', score: 88, icon: 'ri-building-4-line' },
  ]},
  { category: 'Sağlık', items: [
    { name: 'Atakum Devlet Hastanesi', distance: '850m', score: 82, icon: 'ri-hospital-line' },
    { name: 'Özel Klinik', distance: '450m', score: 78, icon: 'ri-first-aid-kit-line' },
  ]},
  { category: 'Ulaşım', items: [
    { name: 'Otobüs Durağı', distance: '120m', score: 98, icon: 'ri-bus-line' },
    { name: 'Sahil Yolu', distance: '200m', score: 92, icon: 'ri-road-map-line' },
  ]},
  { category: 'Alışveriş', items: [
    { name: 'Migros Süpermarket', distance: '280m', score: 90, icon: 'ri-store-2-line' },
    { name: 'Atakum AVM', distance: '1.8km', score: 72, icon: 'ri-shopping-bag-line' },
  ]},
];

export const smartSearchSummary = {
  priceTrend: { direction: 'down', pct: 3.5, label: 'Son 30 günde %3.5 düşüş' },
  competitorCount: 4,
  avgDaysToSell: 35,
  demandLevel: 'Yüksek',
  pricePosition: 'Piyasa Ortası',
  recommendedAction: 'Fiyatı %2-3 indirirseniz 2 hafta içinde satış ihtimali %78.',
  weeklyInterest: [22, 31, 18, 45, 38, 52, 41],
};